export class CoreCommentsModel{
    employeeID: string;
    comment: string;
    createdBy: string;
}